<div class="page-container">
  <div class="page-title-section">
    <h1><mat-icon>business</mat-icon> Concessionárias (CCS)</h1>
    <p class="page-subtitle">Gerencie as concessionárias cadastradas no sistema</p>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input matInput type="text" formControlName="code" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Nome Fantasia</mat-label>
          <input matInput type="text" formControlName="tradeName" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Razão Social</mat-label>
          <input matInput type="text" formControlName="companyName" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CNPJ</mat-label>
          <input matInput type="text" formControlName="document" mask="AA.AAA.AAA/0000-00" />
        </mat-form-field>
      </div>
      <div class="filter-grid cols-3" style="margin-top: 16px;">
        <app-select-form-field
          label="Montadora (OE)"
          [control]="automaker"
          [options]="data.automakers"
          [display]="companyDisplayName"
        />
        <app-select-form-field
          label="Dist. Exclusivo (DE)"
          [control]="distributor"
          [options]="data.distributors"
          [display]="companyDisplayName"
        />
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select placeholder="Selecione o status" formControlName="status">
            <mat-option value="AF">Ativas</mat-option>
            <mat-option value="IF">Inativas</mat-option>
          </mat-select>
        </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar</span>
        </button>
      </div>
      <div class="filter-footer-right">
        <button mat-flat-button color="primary" class="mic-btn-icon-left" routerLink="/dealerships/create">
          <mat-icon>add_circle</mat-icon><span>Cadastrar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" routerLink="/dealerships/import">
          <mat-icon>cloud_upload</mat-icon><span>Importar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" routerLink="/dealerships/export">
          <mat-icon>cloud_download</mat-icon><span>Exportar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micCellTemplate="let item; name: 'activeCell'">
        @if (item.status === 'A') {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'removedCell'">
        @if (item.deleted) {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'actionsCell'">
        <button mat-icon-button color="primary" (click)="redirectToEdit(item)">
          <mat-icon>edit_square</mat-icon>
        </button>
      </ng-container>
    </mic-table>
  </div>
</div>
